import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	title: {
		fontSize: 24,
		fontWeight: 800,
		letterSpacing: "-0.03em",
		color: theme.palette.text.primary,
	}
}));

export default function Title(props) {
	const classes = useStyles();

	return (
		<Typography
			variant="h4"
			className={classes.title}
			gutterBottom
		>
			{props.children}
		</Typography>
	);
}
